module.exports = __webpack_public_path__ + "static/media/buy_block_user_3.6c6ea094.png";